import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule, FeaturesConfigModule } from '@spartacus/core';
import { AtMessageModule, FormErrorsModule, IconModule, MediaModule, MessageComponentModule, ProgressButtonModule, SpinnerModule } from '@spartacus/storefront';
import { GenSpIconsComponent } from 'src/app/generac/shared/components/sp-icons/sp-icons.component';
import { GenQuickOrderComponent } from './quick-order.component';
import { GenQuickOrderFormComponent } from './form/quick-order-form.component';
import { GenQuickOrderTableComponent } from './table/quick-order-table.component';
import { GenQuickOrderItemComponent } from './table/item/quick-order-item.component';
import { GenGreenCheckIconComponent } from '../../shared/components/green-check-icon/green-check-icon.component';
import { GenItemCounterComponent } from '../../shared/components/item-counter/item-counter.component';

@NgModule({
  imports: [
    AtMessageModule,
    CommonModule,
    FormErrorsModule,
    I18nModule,
    IconModule,
    MediaModule,
    MessageComponentModule,
    ProgressButtonModule,
    ReactiveFormsModule,
    SpinnerModule,
    RouterModule,
    UrlModule,
    FeaturesConfigModule,
    GenItemCounterComponent,
    GenSpIconsComponent,
    GenGreenCheckIconComponent,
  ],
  declarations: [
    GenQuickOrderComponent,
    GenQuickOrderFormComponent,
    GenQuickOrderItemComponent,
    GenQuickOrderTableComponent,
  ],
  exports: [
    GenQuickOrderComponent,
    GenQuickOrderFormComponent,
    GenQuickOrderItemComponent,
    GenQuickOrderTableComponent,
  ],
})
export class GenQuickOrderModule {}
